export default class RecaptchaHelper {
    static loaded(timeout) {
        timeout = timeout ?? 30 * 1000;
        const start = Date.now();
        const wait = (resolve, reject) => {
            if (window.grecaptcha) {
                window.grecaptcha.ready(() => resolve(window.grecaptcha));
            } else if (timeout && (Date.now() - start) >= timeout) {
                reject(new Error('Recaptcha timeout'));
            } else {
                setTimeout(wait.bind(this, resolve, reject), 30);
            }
        }
        return new Promise(wait);
    }

    static render(el, siteKey, cb) {

        const expiredCaptcha = function() {
            el.parentElement.removeAttribute('data-captcha');
            el.closest('.recaptcha').nextElementSibling.querySelector('.cta-button-round').classList.add('disabled');
         };

        return grecaptcha?.render(el, {
            'sitekey' : siteKey,
            'callback': cb,
            'expired-callback': expiredCaptcha
        });
    }

    static reset(widgetId) {
        grecaptcha?.reset(widgetId);
    }
}
